import { Square } from "@phosphor-icons/react";
import { SectionShell } from "../Primitives";
import { RADII } from "@/data/designTokens";

export function RadiusSection() {
  return (
    <SectionShell
      id="radius"
      eyebrow="Radius"
      eyebrowIcon={Square}
      title="Soft, rounded, never sharp"
      description="Rounded corners everywhere signal friendliness and safety. Buttons and avatars go fully round; cards and sheets use a generous 32px curve."
    >
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {RADII.map((r) => (
          <div key={r.token} className="rounded-3xl border border-border bg-card p-5 shadow-soft">
            <div
              className={`mb-4 h-20 border-2 border-dashed border-primary/40 bg-primary/10 ${r.cls}`}
              style={r.token === "full" ? { borderRadius: 999 } : undefined}
            />
            <p className="font-display font-extrabold">{r.token}</p>
            <p className="text-sm font-bold text-primary-strong">{r.value}</p>
            <p className="mt-0.5 text-sm font-semibold text-muted-foreground">{r.use}</p>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}

export default RadiusSection;
